export default __webpack_public_path__ + "static/media/icon_tc_white.67b963cb.png";